<div class="card h-full w-full">
  <p-tabMenu [model]="items" class="mb-2"> </p-tabMenu>
  <div class="h-full w-full py-2">
    <router-outlet class="h-full"></router-outlet>
  </div>
</div>
